"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Accordion_1 = __importDefault(require("@opsbase/web-ui/Accordion"));
const AccordionDetails_1 = __importDefault(require("@opsbase/web-ui/AccordionDetails"));
const AccordionSummary_1 = __importDefault(require("@opsbase/web-ui/AccordionSummary"));
const react_1 = __importDefault(require("react"));
const WorkflowActionLabel_1 = __importDefault(require("../WorkflowActionLabel"));
const ActionPicker_1 = __importDefault(require("./ActionPicker"));
function WorkflowActionPicker(props) {
    const { action, onChangeAction, disabled = false, expanded, onExpand, event } = props;
    return (react_1.default.createElement(Accordion_1.default, { expanded: expanded, onChange: onExpand },
        react_1.default.createElement(AccordionSummary_1.default, null,
            react_1.default.createElement(WorkflowActionLabel_1.default, { action: action, expanded: expanded })),
        react_1.default.createElement(AccordionDetails_1.default, null, (action === null || action === void 0 ? void 0 : action.workflowActionConfig) ? (react_1.default.createElement(ActionPicker_1.default, { disabled: disabled, action: action, event: event, onChangeAction: onChangeAction })) : (''))));
}
exports.default = WorkflowActionPicker;
